import { render, staticRenderFns } from "./EditAllowedValuesModal.vue?vue&type=template&id=2a2da0ce&"
import script from "./EditAllowedValuesModal.vue?vue&type=script&lang=js&"
export * from "./EditAllowedValuesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a2da0ce')) {
      api.createRecord('2a2da0ce', component.options)
    } else {
      api.reload('2a2da0ce', component.options)
    }
    module.hot.accept("./EditAllowedValuesModal.vue?vue&type=template&id=2a2da0ce&", function () {
      api.rerender('2a2da0ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/googleSheet/components/EditAllowedValuesModal.vue"
export default component.exports